
export const updateAppAction = data => ({
  type: 'UPDATE_APP',
  data
});